import { FC } from 'react';

import TitleLogo from '../../assets/illust-icons/bznav-title.svg';

const TrpLayout: FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="w-full">
      <div className="mx-auto flex max-w-[1024px] flex-col">
        <div className="px-5 py-4">
          <TitleLogo />
        </div>

        {children}
      </div>
    </div>
  );
};

export default TrpLayout;
